module.exports = __webpack_public_path__ + "static/media/pitje_logo_black.638cedff.png";